import React, { useState, useContext } from 'react';
import { toast } from 'react-toastify';
import { Button, Input } from 'reactstrap';
import { getWebSiteForEntity, refreshFile, getOriginalSite } from 'utils/api';
import VisualSelectorAddingModal from '../modals/VisualSelectorAddingModal';
import {ErrorContext} from 'contexts/ErrorContext';
import SpinnerButton from 'components/SpinnerButton';

function WebAddField(props) {
    const {handleErrors} = useContext(ErrorContext);
    const [previewLoading, setPreviewLoading] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [dataForVS, setDataForVS] = useState(null);

    const getPreview = async () => {
        // let isAlreadyExists = false;
        // props.socialMedias.web.forEach(item => {
        //     if(item.sourceUrl.trim() === inputValue.trim()) {
        //         isAlreadyExists = true;
        //     }
        // })

        // if(isAlreadyExists) {
        //     toast.error('This source is already added');
        // } else {
        const path = inputValue.trim();
        setPreviewLoading(true);
        const params = {
            url: path,
            url_response: true,
            html_response: !process.env.production,
            usage_js: false,
            // entityId: props.activeEntityId
        };
        try {
            // const data = await getWebSiteForEntity(params);
            const data = await getOriginalSite(params);
            !process.env.production && (await refreshFile(data.html));
            data.path = path;

            //For case when we don't have resource in DB and backend don't give usage_js variable
            if(data.usage_js === undefined || data.usage_js === null) {
                data.usage_js = false;
            }
            setDataForVS(data);
            setIsModalOpen(true);
            // const data = {
            //     sourceContent: {
            //         id: null,
            //         name: source.content.title,
            //         screenName: source.content.screenName,
            //         sourceUrl: source.content.sourceUrl,
            //         news: source.content.news,
            //     },
            //     metaData: {
            //         id: null,
            //         title: source.content.title,
            //         screenName: source.content.screenName,
            //         sourceUrl: source.content.sourceUrl,
            //         rssUrl: source.content.rssUrl,
            //     },
            // }
            setPreviewLoading(false);
        } catch(err) {
            console.log(err)
            handleErrors(err)
            // if(e.message && e.message.length < 150) {
            //     toast.error(e.message);
            // }
            setPreviewLoading(false);
        }
    };

    const searchChange = (e) => {
        if (e.key === 'Enter') {
            if(e.target.value.trim()){
                getPreview();
            }
        } else {
            handleInputChange(e.target.value);
        }
    };

    const handleInputChange = (value) => {
        setInputValue(value);
    };

    return (
        <div className="w-100">
            {isModalOpen &&
            <VisualSelectorAddingModal
                isOpen={isModalOpen}
                toggle={() => setIsModalOpen(prevState => !prevState)}
                getPreview={getPreview}
                dataForVS={dataForVS}
                connectItemToCompany={props.addSourceToEntity}
                companyId={props.activeEntityId}
                setInputValue={setInputValue}
            />
            }
            <div className="d-flex">
                <div className="d-flex justify-content-between w-100">
                    <div className="position-relative w-100">
                        <i className="fa fa-cog add-entity-source-input-icon" style={{ color: '#6E7179' }} />
                        <Input
                            onKeyPress={(e) => searchChange(e)}
                            onChange={(e) => searchChange(e)}
                            value={inputValue}
                            placeholder={'Enter the webpage URL'}
                            type="text"
                            className="create-fetch_input"
                            style={{ padding: '0 35px' }}
                            autoComplete="off"
                        />
                        {inputValue.trim() && (
                            <i
                                onClick={() => handleInputChange('')}
                                className="fa fa-times-circle"
                                style={{ position: 'absolute', cursor: 'pointer', right: '0', top: '0', padding: '10.5px' }}
                            />
                        )}
                    </div>
                    {/*<Button*/}
                    {/*    className="calltoaction-button"*/}
                    {/*    style={{ marginLeft: '10px', lineHeight: '0', minWidth: '75px' }}*/}
                    {/*    onClick={() => getPreview()}*/}
                    {/*    disabled={!inputValue.trim() || previewLoading}*/}
                    {/*>*/}
                    {/*    {previewLoading ?*/}
                    {/*        <div className="flex-centered">*/}
                    {/*            <i className="fa fa-spinner fa-spin" />*/}
                    {/*        </div>*/}
                    {/*        :*/}
                    {/*        <React.Fragment>*/}
                    {/*            <span style={{ fontSize: '14px '}}><i style={{ display: 'inline' }} className="fas fa-plus" /></span>&nbsp;*/}
                    {/*            <span style={{ fontSize: '16px' }}>Add</span>*/}
                    {/*        </React.Fragment>*/}
                    {/*    }*/}
                    {/*</Button>*/}
                    <div style={{marginLeft: '10px'}}>
                        <SpinnerButton
                            minWidth="75px"
                            title="Add"
                            iconClass="fas fa-plus"
                            submitting={previewLoading}
                            onClick={getPreview}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WebAddField;
